import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import Icon from '../../design/icons'
import { T, useContent } from '../../content/ContentProvider'

export function Login() {
  const { t } = useContent()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [keepSignedIn, setKeepSignedIn] = useState(true)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const { login } = useAuth()
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await login(username, password)
      navigate('/')
    } catch (err) {
      setError(err.message || t('login.error.failed'))
    } finally {
      setLoading(false)
    }
  }

  const host = typeof window !== 'undefined' ? window.location.hostname : ''
  const isLocal = host.includes('localhost') || host === ''

  return (
    <div className="login-stage">
      <div className="login-art">
        <div className="login-art__grid" />
        <div className="login-art__brand" style={{ position: 'relative' }}>
          <img src="/assets/logo-hitrail.png" alt={t('login.brand.alt')} />
          <span className="login-art__brand-sub">{t('login.brand.sub')}</span>
        </div>
        <div style={{ flex: 1 }} />
        <div className="login-art__quote" style={{ position: 'relative' }}>
          {t('login.art.line1')}<br />
          {t('login.art.line2a')}<b>{t('login.art.line2b')}</b>{t('login.art.line2c')}<br />
          {t('login.art.line3')}
        </div>
        <div className="login-art__meta" style={{ position: 'relative' }}>
          {t('login.art.meta1')}<br />
          {t('login.art.meta2a')}€&nbsp;{t('login.art.meta2b')}
        </div>
      </div>

      <form className="login-form" onSubmit={handleSubmit}>
        <h1>{t('login.heading')}</h1>
        <div className="sub"><T k="login.sub" /></div>

        <div className="env-row">
          <span className="env-tag">{isLocal ? t('login.env.local') : t('login.env.acc')}</span>
          <span className="env-tag env-tag--prd" style={{ opacity: 0.5 }}>{t('login.env.prd')}</span>
        </div>

        {error && (
          <div
            className="status-msg status-msg--err"
            role="alert"
            aria-live="polite"
            style={{ display: 'flex', alignItems: 'center', gap: 8 }}
          >
            {Icon.alert({ s: 14 })}
            <span>{error}</span>
          </div>
        )}

        <div className="fld">
          <label className="fld__label" htmlFor="username">{t('login.field.username')}</label>
          <input
            id="username"
            className="fld__input"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder={t('login.field.usernamePlaceholder')}
            autoComplete="username"
            required
            disabled={loading}
          />
        </div>

        <div className="fld fld--mono">
          <label className="fld__label" htmlFor="password">{t('login.field.password')}</label>
          <input
            id="password"
            className="fld__input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder={t('login.field.passwordPlaceholder')}
            autoComplete="current-password"
            required
            disabled={loading}
          />
          <span style={{ fontSize: 11, color: 'var(--text-dim)', marginTop: 4 }}>
            {t('login.field.passwordHint')}
          </span>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: 'var(--text-muted)' }}>
          <input
            id="keep"
            type="checkbox"
            checked={keepSignedIn}
            onChange={(e) => setKeepSignedIn(e.target.checked)}
            disabled={loading}
          />
          <label htmlFor="keep">{t('login.keepSignedIn')}</label>
        </div>

        <button
          type="submit"
          className="btn btn--primary"
          style={{ justifyContent: 'center', padding: '11px 14px', marginTop: 6, fontSize: 13 }}
          disabled={loading}
        >
          {loading ? t('login.submitBusy') : <>{t('login.submit')} {Icon.arrowRight({ s: 13 })}</>}
        </button>

        <div style={{ display: 'flex', gap: 14, justifyContent: 'space-between', marginTop: 6, fontSize: 12 }}>
          <a style={{ color: 'var(--ht-olive-700)', fontWeight: 500, cursor: 'pointer' }}>{t('login.forgotPassword')}</a>
          <a style={{ color: 'var(--text-dim)', cursor: 'pointer' }}>
            {t('login.ssoSaml')} {Icon.external({ s: 10 })}
          </a>
        </div>

        <div
          style={{
            marginTop: 'auto',
            paddingTop: 32,
            fontSize: 11,
            color: 'var(--text-dim)',
            fontFamily: 'var(--font-mono)',
            display: 'flex',
            gap: 14,
          }}
        >
          <span>{t('login.footer.version')}</span>
          <span>·</span>
          <span>{t('login.footer.region')}</span>
          <span>·</span>
          <span>
            {t('login.footer.statusLabel')}<span style={{ color: 'var(--ok-dark)' }}>{t('login.footer.statusValue')}</span>
          </span>
        </div>
      </form>
    </div>
  )
}
